<template>
  <Modal :open="open" @close="$emit('close')">
    <div class="text-center">
      <h2 class="text-lg font-semibold text-gray-900">{{ t(`${variant}.title`) }}</h2>
    </div>
    <p class="mt-3 text-sm text-gray-700" data-test="description">{{ t(`${variant}.description`, { email }) }}</p>
    <div class="flex justify-end space-x-4 mt-3">
      <SecondaryButton data-test="close-button" @click="$emit('close')">{{ t("close_button") }}</SecondaryButton>
      <GenericButton data-test="confirm-button" :disabled="loading" @click="$emit('confirm')">
        {{ t(`${variant}.confirm_button`) }}
      </GenericButton>
    </div>
  </Modal>
</template>

<script>
import { useI18n } from "vue-i18n";
import { Modal, GenericButton, SecondaryButton } from "@estaly/ui";

export default {
  components: { SecondaryButton, GenericButton, Modal },

  props: {
    open: { type: Boolean, required: true },
    email: { type: String, default: null },
    active: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
  },

  emits: ["close", "confirm"],

  setup() {
    const { t } = useI18n();
    return { t };
  },

  computed: {
    variant() {
      return this.active ? "active" : "to_setup";
    },
  },
};
</script>

<i18n src="./CancelMandateModal.i18n.json"></i18n>
